import { render, staticRenderFns } from "./mention.vue?vue&type=template&id=5d02e865"
import script from "./mention.vue?vue&type=script&lang=js"
export * from "./mention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d02e865')) {
      api.createRecord('5d02e865', component.options)
    } else {
      api.reload('5d02e865', component.options)
    }
    module.hot.accept("./mention.vue?vue&type=template&id=5d02e865", function () {
      api.rerender('5d02e865', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stiker/mention.vue"
export default component.exports